import { useContext, useEffect, useState } from 'react';
import { InterfaceContext } from '../store/InterfaceProvider';
import { useOneMapToken } from '../hooks/UseOneMapToken';
import { GetAllNationalData, getRecent12Months } from '../requests/NationalFeatureRequest';
import { useAfterInit } from '../hooks/useAfterInit';
import { endpoints } from '../store/StaticVariables';

var formSearchInt = null;

const AppController = () => {
    const { setToken, setPast12Months, setNationalData, setAppError } = useContext(InterfaceContext);
    const { token } = useOneMapToken('fa_state_demo', 'SpatialMambo#5', endpoints.useToken);

    const intervalSearch = setInterval(() => {
        let loginModal = document.querySelector('.esri-identity-modal');
        if (loginModal) {
            clearInterval(intervalSearch);
            loginModal.addEventListener('submit', () => {
                formSearchInt = setInterval(() => {
                    let loginModalAgain = document.querySelector('.esri-identity-modal');
                    if (!loginModalAgain) {
                        document.body.classList.remove('password-protect');
                        clearInterval(formSearchInt);
                    }
                }, 100);
            });
        }
    }, 100);
    const initLookups = (token) => {
        setToken(token);
        if (token || endpoints.useToken === false) {
            getRecent12Months({ token })
                .then(setPast12Months)
                .catch((error) => {
                    setAppError(true, 'Recent 12 Months', error);
                });
            GetAllNationalData({ token })
                .then(setNationalData)
                .catch((error) => {
                    setAppError(true, 'National Data', error);
                    setNationalData([]);
                });
        }
    };

    useEffect(() => {
        if (endpoints.useToken) {
            document.body.classList.add('password-protect');
        }
        initLookups(false);
    }, []);

    useAfterInit(() => {
        initLookups(token);
    }, [token]);

    return null;
};

export default AppController;
